module.exports = __webpack_public_path__ + "img/kmtc_logo.2fdd3441.gif";